import styled, { css } from 'styled-components';

const LateralSpace = styled.div(
  ({ theme, left, right }) => `
  ${left ? 'padding-left' : 'padding-right'}: ${theme.constants.lateralSpace};

  
   ${((!left && !right) || (right && left)) &&
     css`
       padding: 0 ${theme.constants.lateralSpace};
     `.join('')}
  };
`,
);

export default styled(LateralSpace)``;
